export default "__VITE_ASSET__4e6f939d__"